(function () {
  'use strict';

  /* @ngdoc object
   * @name relatorios.riskIntelligence
   * @description
   *
   */
  angular
    .module('relatorios.riskIntelligence', [
      'ui.router',
      'FactoryVfiltroModule',
      'ServiceVfiltroModule',
      'ConstantVfiltroModule'
    ]);
}());
